var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3788_10198",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3788_10198",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADrklEQVR4nO1Zv2sUQRjdRIg/UWMhgogKgjbGv0CJgpUgRgtNop2dlT8ghcUlhRg1l+Ng573dJBCIjWyn8UejYGwsjAgSLLRTo41gRNQUmpUvtxfH8fZud2/vcsI9GLjbnW/mvZ1vvvlmxrKaaKKJyCC5A0CP4zgXAPSlUZRSp33fb9H7kf8ke6WY72IjaKwLwHOSfo1Kb7G/TCbTCmCs+E5+y7NE5F3X3UDybg2J+7oAk3xVIoQ8gJdGQ99I3gaQJTmYRgHQI6McRj6RiMBtlr48gAWSQwDarRqBBZ8vO1IiNmpjXQb5JR+tk4BPpX5HFmBM2KFydT3PawNwDcAHkrPiFvIsrgDf91uEYFAGNNIDxeeRIpKESt3nK7lN4MvmcA/GFaCDZL/WVr8VByS7NQF3ItSfLSFgNlanKQu4pBlfTyIAwPvlFNAfxzjEha7+NwI8z2sLRMxWM4l1SHpRapWuvfqU4Ae5UOTI02gCqkKjCchkMq3iUqWy1kQCXNfdo5Q6QrLTtu11Vo2h4s6HMAEA9pN8YYTLHwCGs9ns6obxCBoGQZaYAfCzTJL1DMDmhhMAgAAeGoS/B89eGSJej4yM7GwoAfy3PCK5VUu+zukjIwmdUqqj4QSgQLLf87wVZn2l1DGZC1r9z47jHCjXh23buwCMa2nIW5JQSm2rhYCPAA6VsxHCQlyf3CKsVF0AR8UNQ0b4i+M4x9MU8NS27S0VjQoj0RHsCZZGDcBZo85BkvMVdl0LJK8Ut49VRyErBmQSy2Q2yFyWd67r7gUwp7X9RkbOdd01JA/rdoHtvVwut7GuAgQSTiWsGmTGJMXW023T33MFsvfNyAbgVl0FCCYmJtYCeBDm5yT3lbLzC5Gtj+SvENv6CND2yvrXkzIv86CSLYATJL8uq4AgJb6pzwcAZ6LaA9htLpZ1FUAyZ/jzxbhtAGgn+aTuAox9tZBXSdpJxEe+lNbxDSsmHMc5aUxCL/HhrLXIJ1tsS07FUz9WMWw79YUKwNT4+PiqpOQFxhHnKasSbNveHudgq4gSC9VMtWepo6Ojm/S0Q7jFPlqUIaxUXxYlAO/KLVQpBILpyIaSiBnpQOhWLlhBZ7T6czIaaWwlUeh7sd2w5LBcDJ80Yviw6RL5fH4lycdxF6oIbpPTyQuX2A2VueCYDMT0lchdpqq4LxsOPtpfqbZwyOfz6xv9iskPKZOJyeuowyWfb5TpWD4fFUGIlXXifFp3ZPxTpM3uyKGyiSaasAS/AZObyYHIcwTBAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBanner);
export default __webpack_public_path__ + "static/media/uploadBanner.4ad3710bbad3eee08b6abd50a8a30e95.svg";
export { ForwardRef as ReactComponent };